import { render, staticRenderFns } from "./FieldsForm.vue?vue&type=template&id=6129c0cc&"
import script from "./FieldsForm.vue?vue&type=script&lang=js&"
export * from "./FieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports